import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertStateSubject = new BehaviorSubject<any>(this.getStoredAlert());
  alertState$ = this.alertStateSubject.asObservable();

  /**
   * Mostrar alerta
   * @param alert
   */
  showAlert(alert: { show: boolean; message: string; type: string }): void {
    this.alertStateSubject.next(alert);
    this.storeAlert(alert);
  }

  /**
   * Ocultar alerta
   */
  hideAlert(): void {
    const hiddenAlert = { show: false, message: '', type: '' };
    this.alertStateSubject.next(hiddenAlert);
    this.storeAlert(hiddenAlert);
  }

  /**
   * Almacenar alerta
   * @param alert
   */
  private storeAlert(alert: any): void {
    localStorage.setItem('cayc-alert-state', JSON.stringify(alert));
  }

  /**
   * Obtener alerta almacenada
   * @returns any
   */
  private getStoredAlert(): any {
    const storedAlert = localStorage.getItem('cayc-alert-state');
    return storedAlert
      ? JSON.parse(storedAlert)
      : { show: false, message: '', type: '' };
  }
}
